import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useUpdateSection } from '@hooks';
import { ArrowForwardIcon, Button, Paper, Stack, Typography, Box } from '@esgian/esgianui';
import { SUB_SECTIONS } from '@constants/index';
import { PowerManagementChart } from '@components/Charts';
import { TextWithTooltipIcon } from '@components';
import { getGeneratorSignalsMap } from '@api/helpers';
import { getValue } from '@helpers';

function PowerManagement({ loading, overviewData }) {
  const { updateMainPageSection } = useUpdateSection();

  const { series = [], categories = [] } = useMemo(() => {
    if (!overviewData || !overviewData.data) return {};
    const signals = overviewData.data;
    const generatorMap = getGeneratorSignalsMap(signals);
    
    let cat = [];
    let data = [];
    
    Object.entries(generatorMap).forEach(([generatorNum, metrics]) => {
      cat.push(`Engine ${generatorNum}`);
      // Backend-computed average load while online for the whole period - do not
      // re-average the daily values, that weights every day equally.
      data.push(getValue(metrics['Load_Summary']).toFixed(2));
    });
    
    return { series: [{ data: data }], categories: cat };
  }, [overviewData]);

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Stack spacing={2}>
        <Box>
          <TextWithTooltipIcon
            tooltipText={`Average engine load for each engine while online in the selected time period.`}
            label={<Typography variant={'h6'}>Power Management</Typography>}
          />
          <Typography variant={'body2'}>Average engine load in period</Typography>
        </Box>
        <PowerManagementChart loading={loading} categories={categories} series={series} />
        <Stack direction={'row'} justifyContent={'flex-end'}>
          <Button
            onClick={() => updateMainPageSection(SUB_SECTIONS.POWER_MGMT)}
            endIcon={<ArrowForwardIcon />}
            variant={'outlined'}>
            See power mgmt page
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}

PowerManagement.propTypes = {
  loading: PropTypes.bool,
  overviewData: PropTypes.object
};

PowerManagement.defaultProps = {
  loading: false,
  overviewData: null
};

export default PowerManagement;
